import { render, staticRenderFns } from "./SimpleProductItem.vue?vue&type=template&id=39b6cd4c&scoped=true"
import script from "./SimpleProductItem.vue?vue&type=script&lang=js"
export * from "./SimpleProductItem.vue?vue&type=script&lang=js"
import style0 from "./SimpleProductItem.vue?vue&type=style&index=0&id=39b6cd4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b6cd4c",
  null
  
)

export default component.exports